import { FETCH_CHAT_STATS, FETCH_CHATS_STATS, CHATS_FILTER_SET } from '../../constants/Constants';

export const fetchChatsStats = () => ({ type: FETCH_CHATS_STATS.REQUESTED });
export const fetchChatStats = (projectId, from, to) => ({
  type: FETCH_CHAT_STATS.REQUESTED,
  payload: { projectId, from, to }
});
export const setChatsFilter = filter => ({ type: CHATS_FILTER_SET, payload: filter });



// WEBPACK FOOTER //
// ./src/actions/entities/ChatStatsActions.js